import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

// models
import {ServiceOrderMessageData} from "../models/service-orders/service-order-message-data";
import {ApiMessage} from "../models/api-message";
import {ServiceOrderMessage} from "../models/service-orders/service-order-message";

@Injectable({
    providedIn: 'root'
})
export class ChatMessageService {

    constructor(protected http: HttpClient) {
    }

    // get messages for selected service order ID from in API
    getMessages(id: number): Observable<ServiceOrderMessage[]> {
        return this.http.get<ServiceOrderMessage[]>(`${environment.api}/message?id=${id}`);
    }

    // add/create service order chat message in to API
    createMessage(data: ServiceOrderMessageData): Observable<ApiMessage> {
        return this.http.post<ApiMessage>(`${environment.api}/message`, data);
    }

    // check message for login admin/member only
    checkMessage(): Observable<boolean> {
        return this.http.get<boolean>(`${environment.api}/check-message`);
    }

    // update one service order address in API
    update(id: number, data: Partial<ServiceOrderMessageData>): Observable<ApiMessage> {
        return this.http.put<ApiMessage>(`${environment.api}/message/${id}`, data);
    }

    // delete one chat message from API only for admin
    public delete(id: number): Observable<ApiMessage> {
        return this.http.delete<ApiMessage>(`${environment.api}/message/${id}`);
    }
}
